export const isEnableMerchantTicketsLinkForMerchant = (
  merchantEnableMerchantTicketsLink?: boolean
) => {
  return merchantEnableMerchantTicketsLink ?? true;
};
